import { render } from "./HeroiconsOutlineLightningBolt.vue?vue&type=template&id=4b54bea9"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLightningBolt.vue"]])

export default __exports__